import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import SaveSearchTap from 'lib/Tracking/Srp/SaveSearchTap';
import useEvents from 'lib/hooks/useEvents';
import ClearFiltersTapEvent from 'lib/Tracking/Srp/SearchFilters/ClearFiltersTap';
import { useSrpFilters, useClearSrpFilters } from 'lib/hooks/useSrpFilters';
import useDialog from 'lib/hooks/useDialog';

import { DialogNames } from 'redux-implementations/dialog';

import SaveSearchButton from 'components/Srp/SaveSearchButton';
import State from 'types/State';

import useSaveSearch from 'lib/hooks/useSaveSearch';
import useFetchSavedSearches from 'lib/hooks/useFetchSavedSearches';
import SrpEventContext from 'contexts/SrpEventContext';
import { styles } from './styles';

export default function SaveClearSearchButtons({
  mobileDrawer = false,
  onClose,
  onSignedOutSaveSearch,
  savedSearchId,
}: {
  mobileDrawer?: boolean;
  onClose?: () => void;
  onSignedOutSaveSearch?: () => void;
  savedSearchId?: number;
}): JSX.Element {
  const [isSearchSaved, setIsSearchSaved] = useState(false);
  const savedSearches = useFetchSavedSearches();
  const logger = useEvents();
  const srpEventContext = useContext(SrpEventContext);
  const { t } = useTranslation();
  const { values } = useSrpFilters();
  const clearFilters = useClearSrpFilters();
  const { saveSearch } = useSaveSearch();
  const { open } = useDialog(DialogNames.Auth);
  const isSignedIn = useSelector<State>((state) => state?.session?.isSignedIn);
  const classes = styles();

  const onSaveSearch = (): void => {
    logger.log(SaveSearchTap({ sourcePage: srpEventContext.sourcePage }));
    if (isSignedIn) {
      setIsSearchSaved(true);
      saveSearch();
    } else {
      onClose?.();
      open();
      onSignedOutSaveSearch?.();
    }
  };

  useEffect(() => {
    setIsSearchSaved(false);
  }, [values]);

  useEffect(() => {
    if (savedSearches.length && savedSearchId && savedSearches?.[0]?.id === savedSearchId) {
      setIsSearchSaved(true);
    }
  }, [savedSearchId, savedSearches]);

  const onClearFilters = (): void => {
    logger.log(ClearFiltersTapEvent({ sourcePage: srpEventContext.sourcePage }));
    clearFilters();
  };

  return (
    <div className={`${classes.ctaRow} ${mobileDrawer ? classes.mobileDrawer : ''}`}>
      <Button className={classes.clearFilterButton} onClick={onClearFilters}>
        {t('srp.filters.clearFilters')}
      </Button>
      <SaveSearchButton isSearchSaved={isSearchSaved} onClick={onSaveSearch} />
    </div>
  );
}
